module.exports = __webpack_public_path__ + "05030481be12e1f478ce51f38cd5e41f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/barbell-s.png
// module id = 2482
// module chunks = 0